import { render } from "./index.vue?vue&type=template&id=c515333e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c515333e&lang=less"

import exportComponent from "E:\\Code\\TECS\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__